// Simlar to Error but easy to detect with instanceof
export class InputValidationError extends Error{
	constructor(fieldName, errorName){
        super();
        this.fieldName = fieldName || "field";
        this.errorName = errorName || "required";
        this.name = "InputValidationError";
		this.message = `${this.fieldName} is ${this.errorName.replace(/([A-Z])/g, ' $1')}`;
	}
}